export default "__VITE_ASSET__BxFr5i8x__"